;(function() {
  'use strict'

  Service.$inject = ["$rootScope", "$q", "$log", "glAnalytics", "Responder", "imageService", "locationService", "surveysResource", "usersResource", "promotionsService", "responseTypeService", "geocodeService", "userService"];
  angular.module('app.core').factory('responderService', Service)

  /* @ngInject */
  function Service(
    $rootScope,
    $q,
    $log,
    glAnalytics,
    Responder,
    imageService,
    locationService,
    surveysResource,
    usersResource,
    promotionsService,
    responseTypeService,
    geocodeService,
    userService
  ) {
    var log = $log.create('responderService')

    return {
      submit: submit,
      submitReward: submitReward,
    }

    function submit(responder, onIntercept) {
      return $q(function(resolve, reject) {
        responder.markFinished()

        responder.submitAttempt++

        // fail if we are already submitting
        if (responder.isSubmitting || responder.isSent) {
          return reject()
        }

        // read-only emulate a submission
        if (responder.isReadOnly) {
          return preparePlaceDetails(responder).then(function() {
            console.log(responder.toServer())
            responder.markSent(true)
            resolve()
          })
        }

        var type
        if (responder.didExit) {
          type = responseTypeService.Types.EXIT
        } else if (responder.didQualityExit) {
          type = responseTypeService.Types.QUALITYEXIT
        } else if (responder.didHitQuota) {
          type = responseTypeService.Types.OVERQUOTA
        } else {
          type = responseTypeService.Types.COMPLETE
        }

        // We are seeing some respondent duplicates. The backend
        // rejects these with a 409 but we want to collect some data
        // to verify the circumstances this is happening.
        if (responder.respondentId) {
          glAnalytics.track('respondent-submit', type.toLowerCase(), {
            respondentId: responder.respondentId,
            deviceId: responder.deviceId,
            instanceId: responder.instanceId,
            submitAttempt: responder.submitAttempt,
            time: moment().toISOString(),
            gen: responder.generatorAmount + ':' + responder.generatorParallel,
          })
        }

        responder.isSubmitting = true
        prepare(responder)
          .then(function(auth) {
            var options = {
              auth: auth,
              headers: responder.headers,
            }

            var data = responder.toServer()
            data.type = type
            data.async = false // temporarily disabled
            var amount = responder.generatorAmount
            var parallel = responder.generatorParallel

            // outlinks can intercept to stop or override this request
            var result = onIntercept(data, options)
            if (result) {
              console.log(
                '[submit] onIntercept result',
                JSON.stringify(result, null, 2)
              )
              if (result.cancel) {
                console.log('[submit] cancelled')
                return
              }
              if (result.override) {
                data = result.data
                options = result.options
                type = result.data.type
                console.log('[submit] intercept override data', JSON.stringify(data, null, 2)) // prettier-ignore
                console.log('[submit] intercept override options', JSON.stringify(options, null, 2)) // prettier-ignore
              }
            }

            createResponses(amount, parallel, function() {
              return createResponse(data, options)
            })
              .then(function(resp) {
                // TODO: remove this (used by some old components)
                $rootScope.$emit('survey:responded')

                var options = {}
                switch (type) {
                  case responseTypeService.Types.COMPLETE:
                    options.responseId = resp.id
                    break
                  case responseTypeService.Types.EXIT:
                    options.exitId = resp.id
                    break
                  case responseTypeService.Types.OVERQUOTA:
                    options.quotaHitId = resp.id
                    break
                  case responseTypeService.Types.QUALITYEXIT:
                    options.qualityExitId = resp.id
                    break
                }
                responder.markSent(true, options)

                responder.isSubmitting = false
                resolve()
              })
              .catch(function() {
                responder.markSent(false)
                responder.isSubmitting = false
                reject()
              })
          })
          .catch(function() {
            responder.markSent(false)
            responder.isSubmitting = false
            reject()
          })
      })
    }

    function createResponse(data, options) {
      return $q(function(resolve, reject) {
        surveysResource
          .respond(data, null, options)
          .success(function(x, response) {
            resolve(response)
          })
          .error(function(error) {
            console.log(
              'TODO: if 409 status record to sentry as duplicate responder',
              error
            )
            reject(error)
          })
      })
    }

    function createResponses(amount, parallel, method) {
      return $q(function(resolve, reject) {
        var start = moment()
        var lastResponse
        var batches = []
        var pool = amount

        while (pool > 0) {
          if (pool >= parallel) {
            batches.push(parallel)
            pool -= parallel
          } else {
            batches.push(parallel - pool)
            pool = 0
          }
        }

        function next() {
          var batch = batches.pop()
          var promises = []
          _.times(batch, function() {
            promises.push(method())
          })

          $q.all(promises)
            .then(function(responses) {
              lastResponse = _.last(responses)
              if (batches.length) {
                next()
              } else {
                var duration = moment.duration(moment().diff(start))
                var info = [
                  'Generated ',
                  amount,
                  ' responses (',
                  parallel,
                  ' at a time) in ',
                  duration.hours(),
                  'hrs ',
                  duration.minutes(),
                  'mins ',
                  duration.seconds(),
                  'secs',
                ].join('')
                log.info(info)
                resolve(lastResponse)
              }
            })
            .catch(function() {
              log.error('error generating a batched response')
              reject()
            })
        }
        next()
      })
    }

    function prepare(responder) {
      // add location if any
      responder.location = locationService.latest.position

      return $q
        .all([
          preparePlaceDetails(responder),
          prepareImages(responder),
          prepareEmailUser(responder),
          prepareOneShop(responder), // HACK
        ])
        .then(function(results) {
          // return auth if it came back
          return results[1]
        })
    }

    /**
     * Prepares place details for location places questions.
     * Initially, the location answer is set with an incomplete locality object.
     * This function fetches additional place details to complete the locality object
     * and updates the location answer with the complete information.
     */
    function preparePlaceDetails(responder) {
      var promises = []
      _.each(responder.views, function(view) {
        var question = view.type === responder.Views.QUESTION && view.question
        if (
          !question ||
          question.type !== question.Types.LOCATION ||
          question.locationType !== question.LocationTypes.PLACES ||
          !question.data ||
          !question.data.selectedPlace
        ) {
          return
        }

        var place = question.data.selectedPlace
        var fields = ['formatted_address', 'address_components']
        var promise = geocodeService
          .getPlaceDetails(place.place_id, fields)
          .then(function(placeDetails) {
            _.assign(place, placeDetails)
            // Create a complete locality object from the place details
            var locality = geocodeService.createLocalityObj(place)
            // Update the location answer with the complete locality information
            question.setLocationAnswer(locality)
          })
        promises.push(promise)
      })
      return $q.all(promises)
    }

    function prepareImages(responder) {
      var promises = []
      _.each(responder.views, function(view) {
        var question = view.type === responder.Views.QUESTION && view.question
        if (!question || !question.imageData || question.image) {
          return
        }
        var promise = imageService
          .upload(question.imageData)
          .then(function(imageUrl) {
            question.image = imageUrl
          })
        promises.push(promise)
      })
      return $q.all(promises)
    }

    function prepareEmailUser(responder) {
      return $q(function(resolve, reject) {
        var details = responder.getFollowupDetails()
        if (!details) {
          return resolve()
        }
        userService
          .signupEmail(details.email, details.fullname)
          .then(function(user) {
            setStorageIdentity(responder, user)
            resolve(user)
          })
          .catch(function() {
            reject()
          })
      })
    }

    function setStorageIdentity(responder, user) {
      if (responder.storage) {
        // make our identity the new email-user's id
        responder.storage.identity = user.id
        // Add auth credentials to storage to save to BE
        responder.storage.emailUserAuth = {
          headers: responder.headers,
          auth: user,
        }
      }
    }

    // HACK: Coles OneShop
    // adds region as a custom dimension for specific placesnearme questions
    function prepareOneShop(responder) {
      var questionIds = [
        '49cdc89f-5fd7-4659-9ff1-d74c94f5269a', // How are you going? (production)
        '26809cb8-2dec-4770-a1e6-b02b149dd402', // Your Training Feedback Survey (production)
        '36976c46-103b-4595-b4c9-e54ec6205c21', // Test CRD Hack (staging)
      ]
      _.each(responder.questions, function(question) {
        if (_.includes(questionIds, question.id) && question.selected.length) {
          // careful extraction
          var parenthesesRegex = /\(([^)]+)\)/
          var matches = parenthesesRegex.exec(question.selected[0].name)
          if (matches && matches[1]) {
            responder.setDimension(
              Responder.Dimensions.REPORT,
              'Region',
              matches[1]
            )
          }
        }
      })
    }

    function submitReward(responder, name, email, userId) {
      return $q(function(resolve, reject) {
        var responseData = {
          responseId: responder.responseId,
          exitId: responder.exitId,
          surveyId: responder.id,
        }

        var userData = {
          name: name,
          email: email,
        }

        ensureUser()
          .then(function(auth) {
            responder.storeAutocompletes()

            // create promotion transaction
            promotionsService
              .updateSurveyTransaction(responseData, userData, auth)
              .then(resolve)
              .catch(reject)
          })
          .catch(reject)

        function ensureUser() {
          return $q(function(resolve, reject) {
            if (userId) {
              return resolve()
            }

            // create email-user
            userService
              .signupEmail(email, name)
              .then(function(user) {
                // set storage to this email user and save autocompletes
                setStorageIdentity(responder, user)

                resolve({ auth: user })
              })
              .catch(reject)
          })
        }
      })
    }
  }
})()
